import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCategoryHeirarchy } from '../../../redux/getCategoryHeirarchy';
import NestedUserHeader from '../../../component/reusable/NestedUserHeader';
import AddCustomerForm from '../../../component/allCustomers/AddCustomerForm';
import { getAllAdminThunk } from '../../../redux/admin/adminSlice';

const AddCustomer = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllAdminThunk())

  }, []);

  return (
    <div >
      <NestedUserHeader 
        index="Add Customer"
        root="Dashboard"
        buttonText={'Back to list'}/>
      <AddCustomerForm />
    </div>
  );

};

export default AddCustomer;
